(function () {
    var els = document.querySelectorAll('[data-th-eta]');
    if (!els.length) return;
    function addBusinessDays(d, n) {
      var r = new Date(d.getTime());
      while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
      return r;
    }
    var now = new Date();
    var from = addBusinessDays(now, 3), to = addBusinessDays(now, 7);
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { month: 'short', day: 'numeric' }); };
    els.forEach(function (el) { el.textContent = fmt(from) + ' – ' + fmt(to); });
  })();

(function () {
  var HOL = ['2026-10-12','2026-11-11','2026-11-26','2026-12-25','2027-01-01','2027-01-18','2027-02-15','2027-05-31','2027-06-18','2027-07-05','2027-09-06','2027-10-11','2027-11-11','2027-11-25','2027-12-24','2027-12-31','2028-01-17','2028-02-21','2028-05-29','2028-06-19','2028-07-04','2028-09-04','2028-10-09','2028-11-10','2028-11-23','2028-12-25'];
  function ukToday() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var g = function (t) { return +p.filter(function (x) { return x.type === t; })[0].value; };
      return new Date(Date.UTC(g('year'), g('month') - 1, g('day')));
    } catch (_) { var n = new Date(); return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())); }
  }
  var iso = function (d) { return d.toISOString().slice(0, 10); };
  var isWork = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOL.indexOf(iso(d)) < 0; };
  function addWork(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isWork(x)) n--; } return x; }
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var fmt = function (d) { return d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; };
  var range = function (a, b) { if (iso(a) === iso(b)) return fmt(a); return a.getUTCMonth() === b.getUTCMonth() ? a.getUTCDate() + '–' + fmt(b) : fmt(a) + ' – ' + fmt(b); };
  function run() {
    var today = ukToday();
    document.querySelectorAll('[data-as-eta]').forEach(function (el) {
      if (el.dataset.done) return; el.dataset.done = '1';
      var set = function (k, v) { var b = el.querySelector('[data-eta="' + k + '"]'); if (b) b.textContent = v; };
      set('order', fmt(today));
      var s1 = addWork(today, 1), s2 = addWork(today, 2);
      if (el.dataset.mode === 'pre') {
        if (!el.dataset.release) return;
        var r = new Date(el.dataset.release + 'T00:00:00Z');
        if (r > today) { s1 = isWork(r) ? r : addWork(r, 1); s2 = s1; set('ship', fmt(s1)); }
        else { set('ship', range(s1, s2)); }
        set('deliver', range(addWork(s1, 3), addWork(s2, 5)));
        return;
      }
      set('pack', range(isWork(today) ? today : s1, s1));
      set('ship', range(s1, s2));
      set('deliver', range(addWork(s1, 3), addWork(s2, 5)));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

(() => {
  const box = document.querySelector('[data-as-bundle]');
  if (!box || box.dataset.ready) return; box.dataset.ready = '1';
  const P = window.ASPerks; if (!P) return;
  const variants = JSON.parse(box.querySelector('[data-as-variants]').textContent);
  const bi = Number(box.dataset.packIndex);          // index of the "Bulk price" option, -1 if none
  const title = box.dataset.title, type = box.dataset.type, vendor = box.dataset.vendor;
  const category = P.cat(title, type, vendor);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const scope = box.closest('product-info, .product__info-wrapper, section') || document;
  const FORM_SEL = 'form[action*="/cart/add"][id^="product-form"]:not([id*="installment"])';
  const form = () => scope.querySelector(FORM_SEL) || document.querySelector(FORM_SEL);
  const vid = () => { const f = form(); const i = f && f.querySelector('[name="id"]'); return i ? Number(i.value) : variants[0].id; };
  const qtyInput = () => scope.querySelector('.product-form__quantity input[name="quantity"]') || document.querySelector('.product-form__quantity input[name="quantity"]');
  const qty = () => { const q = qtyInput(); const n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; };
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const minOf = v => bi >= 0 ? P.tierMin(v.options[bi]) : 1;
  const sameModel = (a, b) => a.options.every((o, i) => i === bi || o === b.options[i]);
  const bulkRadios = () => [...scope.querySelectorAll('input[type="radio"][name="Bulk price"]')];
  const bulkSelect = () => scope.querySelector('select[name="options[Bulk price]"], select[name="Bulk price"]');
  let cart = null, lastKey = '';
  // The gift counter sits right below "Add to cart" (the cards stay right above it).
  const orbEl = box.querySelector('[data-as-orb]');
  orbEl.classList.add('as-orb--moved');
  orbEl.appendChild(box.querySelector('.as-bdl__binder'));
  // (This script runs before the buy-buttons block is parsed, so place it once the page is ready.)
  function placeOrb() {
    // Order under the button: Add to cart → payment icons → free gifts → status card (pre-order / delivery dates).
    const card = scope.querySelector('[data-th-status]') || document.querySelector('[data-th-status]');
    if (card) { if (card.previousElementSibling !== orbEl) card.before(orbEl); return true; }
    const pf = scope.querySelector('product-form.main-product-form') || document.querySelector('product-form.main-product-form');
    const wrap = pf && pf.parentElement;
    if (wrap && wrap.parentElement && wrap.nextElementSibling !== orbEl) wrap.after(orbEl);
    return !!wrap;
  }
  placeOrb(); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeOrb);

  // The theme's own "Bulk price" buttons are hidden: the page always shows the standard unit price and
  // the bag moves the line to the right volume price for the total quantity.
  function hideNativeBulk() {
    const r = bulkRadios()[0] || bulkSelect();
    const wrap = r && r.closest('.product-form__input');
    if (wrap) wrap.style.display = 'none';
  }
  function selectStandard() {
    const r = bulkRadios().find(x => P.tierMin(x.value) === 1);
    if (r && !r.checked) { r.click(); const l = scope.querySelector(`label[for="${CSS.escape(r.id)}"]`); if (!r.checked && l) l.click(); return; }
    const s = bulkSelect(); if (s) { const o = [...s.options].find(x => P.tierMin(x.value) === 1); if (o && s.value !== o.value) { s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); } }
  }
  function setQty(n) {
    const q = qtyInput(); if (!q) return;
    q.value = n; q.dispatchEvent(new Event('change', { bubbles: true })); q.dispatchEvent(new Event('input', { bubbles: true }));
  }
  function chips(g) {
    return P.items(g).map(i => `<span class="as-chip">${i.img ? `<img src="${esc(i.img)}" alt="" loading="lazy" width="22" height="22">` : ''}${i.qty > 1 ? i.qty + '× ' : ''}${esc(i.name.replace(/ · .*/, ''))}${i.dot ? `<i style="background:${i.dot}"></i>` : ''}</span>`).join('');
  }
  // Units of this product already in the bag (all models) — they count towards the volume price.
  const pid = Number(box.dataset.productId);
  const bagUnits = () => cart ? cart.items.filter(i => !P.isGift(i) && i.product_id === pid).reduce((n, i) => n + i.quantity, 0) : 0;

  function render() {
    const cur0 = variants.find(x => x.id === vid()) || variants[0];
    const tiers = bi >= 0 ? variants.filter(v => sameModel(v, cur0)).sort((a, b) => minOf(a) - minOf(b)) : [];
    const std = tiers.find(v => minOf(v) === 1) || cur0;
    const cur = tiers.length ? std : cur0;
    if (tiers.length && minOf(cur0) !== 1) selectStandard();
    const q = qty(), inBag = bagUnits(), total = q + inBag;
    const active = tiers.filter(v => minOf(v) <= total && v.available).pop() || std;
    const unit = active.price;
    lastKey = [cur0.id, q, inBag].join('|');
    const bagLines = cart ? P.linesFromCart(cart) : [];
    // ---- volume price cards
    const packsBox = box.querySelector('[data-as-packs]');
    if (tiers.length > 1) {
      hideNativeBulk();
      packsBox.hidden = false;
      box.querySelector('.as-bdl__opts').innerHTML = tiers.map((v, i) => {
        const n = minOf(v), save = std.price - v.price;
        const last = i === tiers.length - 1;
        const pl = P.plan([{ title, type, vendor, paid: v.price * n, units: n }]);
        const g = '';
        const name = n === 1 ? '1 unit' : `${n}${last ? '+' : ''} units`;
        const badge = i === 1 ? '<span class="as-opt__badge">Popular</span>' : i === 2 ? '<span class="as-opt__badge">Best value</span>' : '';
        const deal = n === 1 ? 'Standard price' : `${P.money(v.price)} each · save ${P.money(save)} each`;
        const on = v.id === active.id;
        return `<button type="button" class="as-opt" role="radio" aria-checked="${on}" data-n="${n}"${v.available ? '' : ' disabled'}>
          <span class="as-opt__dot" aria-hidden="true"></span>
          <span class="as-opt__main"><span class="as-opt__name">${name} ${badge}${save > 0 ? `<span class="as-opt__badge as-opt__badge--save">Save ${P.money(save * n)}</span>` : ''}</span><span class="as-opt__deal">${v.available ? deal : 'Not available at this quantity'}</span></span>
          <span class="as-opt__price"><b>${P.money(v.price * n)}</b>${save > 0 ? `<s>${P.money(std.price * n)}</s>` : ''}</span>
          ${g ? `<span class="as-opt__gifts"><span class="as-chip as-chip--free">FREE</span>${g}</span>` : ''}
        </button>`;
      }).join('') + (inBag ? `<p class="as-bdl__note">You already have ${inBag} in your bag — they count too: ${q} more = <b>${P.money(unit)} each</b>.</p>` : (q > 1 ? `<p class="as-bdl__note">${q} units · <b>${P.money(unit)} each</b> · ${P.money(unit * q)} total</p>` : ''));
    } else packsBox.hidden = true;
    // ---- products without volume prices (e.g. graded cards): show what comes free with them
    const ownBox = box.querySelector('[data-as-own]');
    const ownG = P.plan([{ title, type, vendor, paid: cur0.price, units: 1 }]).g;
    const twoG = P.plan([{ title, type, vendor, paid: cur0.price * 2, units: 2 }]).g;
    if (false) {
      const extra = P.items(twoG).filter(i => !ownG[i.key] || twoG[i.key] > ownG[i.key]);
      ownBox.innerHTML = `<p class="as-own__k">Included free</p><div class="as-own__chips">${chips(ownG)}</div>`
        + (extra.length ? `<p class="as-own__more">Add a second one and you also get: <b>${esc(P.label(Object.fromEntries(extra.map(i => [i.key, twoG[i.key] - (ownG[i.key] || 0)]))))}</b>.</p>` : '');
      ownBox.hidden = false;
    } else ownBox.hidden = true;

    // ---- gifts with bag + this selection
    const mine = { title, type, vendor, paid: unit * q, units: q };
    const withBag = P.plan(bagLines.concat([mine]));
    const bw = orbEl.querySelector('.as-bdl__binder');
    bw.hidden = !withBag.g.binder || !cur.available;
    if (!bw.hidden) {
      bw.querySelector('[data-as-colour]').textContent = P.getColour();
      bw.querySelector('.as-bdl__sw').innerHTML = P.colours.map(c => `<button type="button" class="as-sw" role="radio" aria-checked="${c === P.getColour()}" aria-label="${esc(c)}" title="${esc(c)}" data-c="${esc(c)}" style="background:${P.G.binder.swatch[c] || '#999'}"></button>`).join('');
    }
    // ---- orbit counter
    const orb = orbEl;
    if (!P.C.on || category === 'none') { orb.hidden = true; return; }
    orb.hidden = false;
    orb.querySelector('[data-as-orb-fill]').style.width = Math.min(100, withBag.sub / Math.max(1, P.C.o2) * 100) + '%';
    orb.querySelector('[data-as-orb-nodes]').innerHTML = P.ORBITS.map((o, i) => `<li class="${withBag.owned(o.key) ? 'is-on' : ''}"><i>${withBag.owned(o.key) ? '✓' : i + 1}</i><span><b>${esc(o.label)}</b>${P.money(o.from())}</span></li>`).join('');
    orb.querySelector('[data-as-orb-now]').textContent = `${bagLines.length ? 'Bag + this' : 'This'}: ${P.money(withBag.sub)}`;
    const short = v => P.money(v).replace(/\.00$/, '');
    const msg = P.ORBITS.map(o => {
      const on = withBag.owned(o.key), need = Math.max(0, o.from() - withBag.sub);
      const todo = o.key === 'binder' ? `Add ${P.money(need)} more and pick your colour` : `Add ${P.money(need)} more`;
      return `<li class="${on ? 'is-on' : ''}"><i aria-hidden="true">${on ? '✓' : ''}</i><span><b>${esc(o.label)}</b> · from ${short(o.from())}</span><em>${on ? 'Included' : todo}</em></li>`;
    }).join('') + (bagLines.length ? `<li class="as-orb__bag"><span>Counting your bag (${P.money(P.plan(bagLines).sub)}) + this item.</span></li>` : '');
    orb.querySelector('[data-as-orb-msg]').innerHTML = msg;
  }

  box.addEventListener('click', e => {
    const o = e.target.closest('[data-n]'); if (o && !o.disabled) { const inBag = bagUnits(); setQty(Math.max(1, Number(o.dataset.n) - (Number(o.dataset.n) > 1 ? inBag : 0))); setTimeout(render, 30); return; }

  });
  orbEl.addEventListener('click', e => {
    const s = e.target.closest('[data-c]'); if (s) { const had = s === document.activeElement, c = s.dataset.c; P.setColour(c); if (had) { const el = orbEl.querySelector(`[data-c="${CSS.escape(c)}"]`); if (el) el.focus(); } }
  });
  document.addEventListener('as:binder', render);
  async function loadCart() { try { cart = await (await fetch(root + 'cart.js', { credentials: 'same-origin' })).json(); } catch (_) {} render(); }
  setInterval(() => { if ([vid(), qty(), bagUnits()].join('|') !== lastKey) render(); }, 400);
  const dlg = document.getElementById('tcg-cart'); if (dlg) dlg.addEventListener('close', loadCart);
  else document.addEventListener('DOMContentLoaded', () => { const d = document.getElementById('tcg-cart'); if (d) d.addEventListener('close', loadCart); });

  // Product FAQ: "[gifts]" → what this product brings on its own.
  const faqGifts = function () {
    const v = variants.find(x => minOf(x) === 1) || variants[0];
    const lbl = P.label(P.plan([{ title, type, vendor, paid: v.price, units: 1 }]).g);
    let txt;
    if (lbl) txt = `With one unit of this product you get: ${lbl}.`;
    else if (category !== 'none') txt = `This product counts towards our free gifts — everything in your order counts: free card sleeves + toploaders from ${P.money(P.C.o1)} and a free Vault X binder from ${P.money(P.C.o2)}.`;
    else txt = 'This product has no gift of its own, but it never stops other items in your bag from unlocking theirs.';
    document.querySelectorAll('[data-as-faq-gifts]').forEach(el => { el.textContent = txt; });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { faqGifts(); hideNativeBulk(); }); else faqGifts();
  hideNativeBulk();
  loadCart();
})();

(function () {
      var root = document.getElementById('TH-Rev-as');
      if (!root) return;

      var track = root.querySelector('[data-th-track]');
      var slides = root.querySelectorAll('[data-th-slide]');
      var dots = root.querySelectorAll('[data-th-dot]');
      if (!track || slides.length < 2) return;

      var index = 0;
      var autoplay = root.dataset.autoplay === 'true';
      var speed = (parseFloat(root.dataset.speed) || 5) * 1000;
      var timer = null;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';

        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
        });
      }

      var prev = root.querySelector('[data-th-prev]'), next = root.querySelector('[data-th-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(index + 1); restart(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(parseInt(dot.getAttribute('data-th-dot'), 10));
          restart();
        });
      });

      function start() {
        if (!autoplay) return;
        timer = setInterval(function () { go(index + 1); }, speed);
      }

      function restart() {
        clearInterval(timer);
        start();
      }

      var startX = 0;
      var moved = false;

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        moved = false;
        clearInterval(timer);
      }, { passive: true });

      track.addEventListener('touchmove', function () { moved = true; }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (!moved) { start(); return; }
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) {
          go(delta < 0 ? index + 1 : index - 1);
        }
        restart();
      });

      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', start);

      go(0);
      start();
    })();
